// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"112":"cfdb2eff","680":"4298eeb3"}[chunkId] + ".chunk.css";
};